import { render, staticRenderFns } from "./AverageValues.vue?vue&type=template&id=85b4f1d4&"
import script from "./AverageValues.vue?vue&type=script&lang=js&"
export * from "./AverageValues.vue?vue&type=script&lang=js&"
import style0 from "./AverageValues.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports